<template>
  <GamButton :class="[{ 'is-huge': isHuge }]" v-bind="GetCoordinatesButton" />
</template>

<script setup lang="ts">
import { RouterNameType } from '@/core/data/config/uiConfig.interface';
import { formatLatLng, isValidLocation } from '@/core/helpers/list.helper';
import { isHuge } from '@/core/helpers/ui.helper';
import { useMapStore } from '@/stores/map.store';
import { GamButtonSize, GamButtonVariant } from '@/views/composables/constants/components/gamButton.constants';
import { GamIconName } from '@/views/composables/constants/components/gamIcon.constants';
import type { GamButtonType } from '@/views/composables/models/components/GamButton';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import GamButton from '../GamButton.vue';

const mapStore = useMapStore();
const { currentLocation, currentZoom } = storeToRefs(mapStore);
const router = useRouter();

const GetCoordinatesButton = computed((): GamButtonType => {
  return {
    variant: GamButtonVariant.AFFORDED,
    size: GamButtonSize.SMALL,
    isCentered: true,
    isDeepShadow: true,
    leftIcon: GamIconName.MAP,
    label: isValidLocation(currentLocation.value) ? formatLatLng(currentLocation.value!) : 'Map',
    containerClass: 'location-button',
    onClick: () => {
      router.push({
        name: RouterNameType.LOCATIONS,
        query: {
          lat: currentLocation.value?.lat,
          lng: currentLocation.value?.lng,
          zoom: currentZoom.value,
        },
      });
    },
  };
});
</script>
